__turbopack_context__.v({
  "asideIcon": "SiteNav-module__c5LMza__asideIcon",
  "asideText": "SiteNav-module__c5LMza__asideText",
  "bar": "SiteNav-module__c5LMza__bar",
  "burger": "SiteNav-module__c5LMza__burger",
  "burgerLines": "SiteNav-module__c5LMza__burgerLines",
  "chevron": "SiteNav-module__c5LMza__chevron",
  "cta": "SiteNav-module__c5LMza__cta",
  "desktop": "SiteNav-module__c5LMza__desktop",
  "entries": "SiteNav-module__c5LMza__entries",
  "entry": "SiteNav-module__c5LMza__entry",
  "link": "SiteNav-module__c5LMza__link",
  "logo": "SiteNav-module__c5LMza__logo",
  "menuCopy": "SiteNav-module__c5LMza__menuCopy",
  "menuDescription": "SiteNav-module__c5LMza__menuDescription",
  "menuIcon": "SiteNav-module__c5LMza__menuIcon",
  "menuItem": "SiteNav-module__c5LMza__menuItem",
  "menuItems": "SiteNav-module__c5LMza__menuItems",
  "menuTitle": "SiteNav-module__c5LMza__menuTitle",
  "mobile": "SiteNav-module__c5LMza__mobile",
  "mobileCta": "SiteNav-module__c5LMza__mobileCta",
  "mobileEntries": "SiteNav-module__c5LMza__mobileEntries",
  "mobileEntry": "SiteNav-module__c5LMza__mobileEntry",
  "mobileLink": "SiteNav-module__c5LMza__mobileLink",
  "mobileMenu": "SiteNav-module__c5LMza__mobileMenu",
  "panel": "SiteNav-module__c5LMza__panel",
  "panelAside": "SiteNav-module__c5LMza__panelAside",
  "panelMain": "SiteNav-module__c5LMza__panelMain",
  "root": "SiteNav-module__c5LMza__root",
});
